<template>
  <div class="app-login">
    <form class="app-login-form" @submit.prevent="entrar">
      <img class="app-login-logo" src="../assets/img/logo_white.png" alt="Eurocaja Rural"/>
      <h4 class="app-login-title">Portal de Proveedores de Confirming</h4>
      <div class="form-group">
        <div class="mensajeErrorReducido" v-if="confirmacion=='KO'">
          <p>warning</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <span class="app-firstLogin-information">Si accedes al servicio por primera vez, introduce el código de identificación fiscal del proveedor y la clave que te 
          hemos remitido en la Notificación de pago y pulsa 'Entrar'</span>
        <input class="inputLoginComponent" type="text" name="documentId" placeholder="NIF/CIF *" v-model="cif" required/>
        <input class="inputLoginComponent" maxlength="8" required :type="textPass1" name="token" placeholder="Clave *" v-model="token"/>
        <span class="material-icons visibility" id="eye1" @click="showPassword" v-if="eye1">visibility</span>
        <span class="material-icons visibility" id="eye1" @click="hidePassword" v-if="!eye1">visibility_off</span>
        <br>
        <input class="btnPrimary" type="submit" value="Entrar" :disabled="isDisabled">
        <div class="app-login-disclaimer">
          <div class="icon-lock">
            
          </div>
          <p>
              Recomendaciones de Seguridad:
              <br/>
              <br/>
              Mantén tus claves en secreto y cámbialas regularmente.
              <br/>
              No introduzcas la Clave de Firma para consulta de saldo, movimientos, o sin haber iniciado ninguna operación.
              <br/>
              No olvides pulsar salir al terminar tu sesión.
              <br/>
              Nunca te solicitaremos tus claves personales y confidenciales por teléfono, correo electrónico o fax, ni te pediremos que realices ninguna prueba de operaciones en tu oficina digital.
              <br/>
              <br/>
              Si tienes dudas, llama a nuestro servicio de Atención al cliente 925 26 96 44.
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "FirstLoginNoClientComponent",
  data() {
    return {
      cif:null,
        mensajeError: null,
        confirmacion:null,
        eye1:true,
      textPass1 : "password",
      token:null
    }
  },
  computed : {
    isDisabled: function() {
        return !this.cif || !this.token;
    }
  },
  methods : {
    numericInput(a) {
      if (a.which < 48 || a.which > 57) {
        a.preventDefault();
      }
    },
    showPassword() {
      this.eye1= false;
      this.textPass1 = "text";
    },
    hidePassword() {
      this.eye1= true;
      this.textPass1 = "password";
    },
    obtenerDatosContrato(){
      var ventana=this;
      const baseURI = '/api-users/users/me';
      let loader = this.$loading.show();
      this.$http.get(baseURI)
      .then((result) => {
        this.$router.push({ name:'registroCliente', 
          params: { 
            token:true, //indicador de que el token es valido y que estamos accediendo desde este componente
            datosContrato:result.data.data.profiles[0] //cogemos los datos del primer y unico perfil
          }
        });
      })
      .catch(function (error) {
        if(error.response){
                if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                  ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                }else{ //si no, por defecto
                  ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
              }
              ventana.confirmacion='KO';
              window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
      })
      .then(function () {
        loader.hide();
      });
    },
    entrar() {
      const ventana=this;
      const baseURI = '/auth-server/oauth/token';
      const options = {
        headers: {
            'Authorization':'Basic Zmlyc3RMb2dpbkNvbmZpcm1pbmc6ZW5yb2wxMjQ='
        }
      };
      const params = new URLSearchParams();
      params.append('username', this.cif);
      params.append('password', this.token);
      params.append('grant_type', 'password');
      let loader = this.$loading.show();
      //llamamos al servicio de validacion de token
      this.$http.post(baseURI, params ,options)
      .then((result) => {
        this.$cookies.set('RT',result.data.refresh_token);
        this.$http.defaults.headers.common['Authorization'] = 'Bearer '+result.data.access_token; //esto establece nuestro access token en el header autorizacion de todas las llamadas, siempre que estemos logeados
        this.obtenerDatosContrato(); //obtiene los datos del contrato
      })
      .catch(function (error) {
        if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    ventana.datosFirma = error.response.data.result.errors[0].info;
                    ventana.beforeSubmit = false;
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                    ventana.confirmacion='KO';
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }else{
                  if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                    ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                  }
                  ventana.confirmacion='KO';
                  ventana.$http.defaults.headers.common['Authorization'] = null;
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                }
        }
      })
      .then(function () {
        loader.hide();
      });
    }
  }
}
</script>